<template>
  <div>
    <VDropdown ref="dropdown" right>
      <template #button="{ open }">
        <button
          type="button"
          class="h-8 w-8 inline-flex items-center justify-center bg-white text-gray-800 focus:bg-gray-800 focus:text-white focus:outline-none hover:bg-gray-800 hover:text-white rounded-full"
          @click="open"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-4 h-4">
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm14
              0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-7 0c-1.1
              0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
            />
          </svg>
        </button>
      </template>

      <div
        class="origin-top-right absolute right-0 mt-2 w-56 rounded shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div class="py-1">
          <button
            type="button"
            class="block w-full px-4 py-2 text-right text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
            role="menuitem"
            @click="handleShowSupplementaryDescriptions"
          >
            Supplementary Description
          </button>
        </div>
        <div class="py-1">
          <button
            type="button"
            class="block w-full px-4 py-2 text-right text-sm text-red-700 hover:bg-gray-100 hover:text-red-900 focus:outline-none"
            role="menuitem"
            @click="handleRemove"
          >
            Delete
          </button>
        </div>
      </div>
    </VDropdown>

    <TableLineSupplementaryDescriptionModal
      v-if="showSupplementaryDescriptions"
      :content="offerLine.supplementaryDescription"
      @update="$emit('update-supplementary-description', $event)"
      @close="setShowSupplementaryDescriptions(false)"
    />
  </div>
</template>

<script>
import VDropdown from 'Components/Common/VDropdown.vue';
import TableLineSupplementaryDescriptionModal from './TableLineSupplementaryDescriptionModal.vue';

export default {
  components: {
    VDropdown,
    TableLineSupplementaryDescriptionModal,
  },
  props: {
    offerLine: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showSupplementaryDescriptions: false,
    };
  },
  methods: {
    setShowSupplementaryDescriptions(value) {
      this.showSupplementaryDescriptions = Boolean(value);
    },
    handleShowSupplementaryDescriptions() {
      this.$refs.dropdown.closeMenu();
      this.setShowSupplementaryDescriptions(true);
    },
    handleRemove() {
      this.$refs.dropdown.closeMenu();
      this.$emit('remove');
    },
  },
};
</script>
